import { api } from '@/services/apiClient'
import { Me } from '@/services/AuthService'

// import * as T from './types'

// export const getMe = async (payload: T.Session): Promise<T.UserOut> => {
//   const { data } = await api.get<T.UserOut>(`/me`)
//   return data
// }
//
// export const fetchCurrentPermissionsAt = async (municipality_id: string, payload: T.Session): Promise<any> => {
//   const { data } = await api.get<any>(`/get_current_partner_permissions_at/${municipality_id}`)
//   return data
// }
// TODO: Remove anys
export const getUser = async (user_id: string): Promise<Me> => {
  const { data } = await api.get<Me>(`/users/${user_id}`)
  return data
}

export const getUsersForEntity = async (entity_type: string, entity_id: string): Promise<any> => {
  const { data } = await api.get<any>(`/users/in-entity/${entity_type}/${entity_id}`)
  return data
}

export interface UserStatusUpdate {
  is_active?: boolean
  is_primary_contact?: boolean
}

export const updateUserStatus = async (userId: string, payload: UserStatusUpdate): Promise<Me> => {
  const { data } = await api.put<Me>(`/users/${userId}`, payload)
  return data
}

export interface UserPreferencesUpdate {
  theme_preference?: 'dark' | 'light'
  language_preference?: 'es' | 'en' | 'pt'
}

export const updateMyPreferences = async (payload: UserPreferencesUpdate): Promise<Me> => {
  const { data } = await api.put<Me>('/users/me/preferences', payload)
  return data
}

export interface UserProfileUpdate {
  first_name?: string
  last_name?: string
  second_last_name?: string | null
  phone_number?: string | null
}

export const updateMyProfile = async (payload: UserProfileUpdate): Promise<Me> => {
  const { data } = await api.put<Me>('/users/me/profile', payload)
  return data
}

export const updateUserProfile = async (
  userId: string,
  payload: UserProfileUpdate
): Promise<Me> => {
  const { data } = await api.put<Me>(`/users/${userId}/profile`, payload)
  return data
}

export interface PasswordChangePayload {
  current_password: string
  new_password: string
}

export const changeMyPassword = async (payload: PasswordChangePayload): Promise<void> => {
  await api.put('/users/me/password', payload)
}
